import { render, staticRenderFns } from "./VerAuxiliar.vue?vue&type=template&id=d4402d06"
import script from "./VerAuxiliar.vue?vue&type=script&lang=js"
export * from "./VerAuxiliar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports